function loadHlsLibrary(libUrl) {
  if (window.Hls) {
    return Promise.resolve();
  }

  if (!window._hlsLibraryLoading) {
    window._hlsLibraryLoading = new Promise((resolve, reject) => {
      var script = document.createElement('script');
      script.src = libUrl;
      script.defer = true;
      script.onload = function () { resolve(); };
      script.onerror = function () { reject(new Error('Failed to load HLS library')); };
      document.head.appendChild(script);
    });
  }

  return window._hlsLibraryLoading;
}

function getHighestQualityLevel(levels) {
  var bestIndex = 0;
  var bestScore = -1;

  levels.forEach(function (level, index) {
    var height = level.height || 0;
    var bitrate = level.bitrate || 0;
    var score = height * 1e9 + bitrate;
    if (score > bestScore) {
      bestScore = score;
      bestIndex = index;
    }
  });

  return bestIndex;
}

function lockHighestQuality(hls) {
  if (!hls || !hls.levels || !hls.levels.length) return;
  var highestLevel = getHighestQualityLevel(hls.levels);
  hls.currentLevel = highestLevel;
  hls.loadLevel = highestLevel;
  hls.nextLevel = highestLevel;
}

function attemptPlay(video) {
  video.muted = true;

  var playPromise = video.play();
  if (playPromise !== undefined) {
    playPromise.catch(function () {
      video.muted = true;
      var events = ['click', 'touchstart', 'scroll', 'keydown'];
      function retry() {
        events.forEach(function (e) {
          document.removeEventListener(e, retry, { capture: true });
        });
        video.muted = true;
        video.play().catch(function () {});
      }
      events.forEach(function (e) {
        document.addEventListener(e, retry, { capture: true, once: true });
      });
    });
  }
}

function initHlsVideos(root) {
  if (!root) root = document;
  var videos = root.querySelectorAll('video[data-hls-src]:not([data-hls-initialized])');
  if (!videos.length) return;

  var libUrl = videos[0].dataset.hlsLib;
  if (!libUrl) return;

  loadHlsLibrary(libUrl)
    .then(function () {
      videos.forEach(function (video) {
        var src = video.dataset.hlsSrc;
        if (!src || video.dataset.hlsInitialized) return;

        video.dataset.hlsInitialized = 'true';

        // Always prefer hls.js when supported — Chrome can falsely claim
        // native HLS support via canPlayType but then fail to actually play.
        if (typeof Hls !== 'undefined' && Hls.isSupported()) {
          if (video._hls) {
            video._hls.destroy();
          }

          var hls = new Hls({
            autoStartLoad: true,
            startLevel: -1,
            capLevelToPlayerSize: false,
            abrEwmaDefaultEstimate: 20e6,
            maxBufferLength: 30,
            maxMaxBufferLength: 60,
          });
          video._hls = hls;
          hls.loadSource(src);
          hls.attachMedia(video);

          hls.on(Hls.Events.MANIFEST_PARSED, function () {
            lockHighestQuality(hls);
            attemptPlay(video);
          });

          video.addEventListener('seeking', function () {
            lockHighestQuality(hls);
          });
          hls.on(Hls.Events.LEVEL_SWITCHING, function (_event, data) {
            var highestLevel = getHighestQualityLevel(hls.levels);
            if (data.level !== highestLevel) {
              lockHighestQuality(hls);
            }
          });

          hls.on(Hls.Events.ERROR, function (_event, data) {
            if (!data.fatal) return;
            if (data.type === Hls.ErrorTypes.NETWORK_ERROR) {
              hls.startLoad();
            } else if (data.type === Hls.ErrorTypes.MEDIA_ERROR) {
              hls.recoverMediaError();
            } else {
              hls.destroy();
              video.dataset.hlsInitialized = '';
              video._hls = null;
              setTimeout(function () { initHlsVideos(video.parentElement); }, 2000);
            }
          });
          return;
        }

        // Fallback: native HLS (Safari / iOS where MSE is unavailable)
        if (video.canPlayType('application/vnd.apple.mpegurl')) {
          video.src = src;
          video.addEventListener('loadedmetadata', function () {
            attemptPlay(video);
          }, { once: true });
          video.addEventListener('canplay', function () {
            if (video.paused) attemptPlay(video);
          }, { once: true });
          return;
        }

        console.warn('HLS playback is not supported in this browser.');
      });
    })
    .catch(function () {
      console.warn('Failed to load HLS playback library.');
    });
}

function setupHlsVideoListeners() {
  if (!window._hlsVideoListenersReady) {
    window._hlsVideoListenersReady = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initHlsVideos(); });
    }

    document.addEventListener('shopify:section:load', function (event) {
      initHlsVideos(event.target);
    });
  }

  if (document.readyState !== 'loading') {
    initHlsVideos();
  }
}

setupHlsVideoListeners();
